import React from "react";
import { Image } from "react-native";
import Stack from "../Stack";
import Typography from "../Typography";
import Box from "../Box";

interface PropsType {
  picture_url?: string;
  name?: string;
  size: number;
}

function Avatar(props: PropsType) {
  return (
    <>
      {props.picture_url ? (
        <Image
          style={{
            width: props.size,
            height: props.size,
          }}
          source={{ uri: props.picture_url }}
        />
      ) : (
        <Box
          bg="secondary.main"
          br="l"
          style={{ width: props.size, height: props.size }}
        >
          <Stack
            distribution="center"
            alignment="center"
            direction="vertical"
            style={{ flex: "auto" }}
          >
            <Typography fs="s" color="common.white">
              {props.name?.charAt(0).toUpperCase() ?? "-"}
            </Typography>
          </Stack>
        </Box>
      )}
    </>
  );
}

export default Avatar;
